import { render, staticRenderFns } from "./ChartDetails.vue?vue&type=template&id=18bc2d31&"
import script from "./ChartDetails.vue?vue&type=script&lang=js&"
export * from "./ChartDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports